import { getGenders } from "entities/user"
import { formatCountry } from "entities/country"

export const BILLING_CURRENCIES = ["eur", "chf"]
export const DEFAULT_BILLING_CURRENCY = "eur"

export const formatCurrency = (currency) => currency?.toUpperCase()

export const formatBillingAddressLabel = (billingAddress) => {
  if (!billingAddress.currency) {
    return billingAddress.label
  }
  return `${billingAddress.label} (${formatCurrency(billingAddress.currency)})`
}

export const isForeignCurrencyAddress = (billingAddress) =>
  !!billingAddress?.currency &&
  billingAddress.currency !== DEFAULT_BILLING_CURRENCY

export const getInitialValues = (billingAddress) => {
  const genders = getGenders()
  let gender
  let country
  let zip
  let city

  if (typeof billingAddress?.gender === "string") {
    gender = genders.find((gender) => gender.id === billingAddress.gender)
  } else {
    gender = billingAddress?.gender
  }

  if (typeof billingAddress?.country === "string") {
    country = {
      id: billingAddress.country,
      name: billingAddress.country.toUpperCase()
    }
  } else {
    country = billingAddress?.country
  }

  if (typeof billingAddress?.city === "string") {
    zip = { zip_code: billingAddress.zip }
  } else {
    zip = billingAddress?.zip
  }

  if (typeof billingAddress?.city === "string") {
    city = { city: billingAddress.city }
  } else {
    city = billingAddress?.city
  }

  return {
    company: billingAddress?.company ?? "",
    department: billingAddress?.department ?? "",
    title: billingAddress?.title ?? "",
    first_name: billingAddress?.first_name ?? "",
    last_name: billingAddress?.last_name ?? "",
    gender: billingAddress?.gender ? gender : null,
    salutation: billingAddress?.salutation ?? "",
    ust_vat: billingAddress?.ust_vat ?? "",
    without_vat_id: billingAddress?.without_vat_id ?? false,
    street: billingAddress?.street ?? "",
    street_number: billingAddress?.street_number ?? "",
    country: billingAddress?.country ? country : null,
    zip: billingAddress?.zip ? zip : null,
    city: billingAddress?.city ? city : null,
    is_default: billingAddress?.is_default ?? false,
    currency: billingAddress?.currency ?? DEFAULT_BILLING_CURRENCY
  }
}

export const getFullAddress = (billingAddress) => {
  const { country, city, street, street_number, zip } = billingAddress
  const cityName = city?.city ?? city
  const zipCode = zip?.zip_code ?? zip
  const countryName = country?.name
    ? formatCountry(country)
    : formatCountry({ name: country })

  return `${street} ${street_number}, ${cityName}, ${zipCode}, ${countryName}`
}

/** @param {{is_default: boolean}[]} data */
export const findDefaultBillingAddress = (data) => {
  return data.find((d) => d.is_default) ?? null
}
